import React from 'react';
import CollaborationPanel from '@/components/module/projects/collaboration_tab/CollaborationPanel';

export default function ProjectCollaborationTab({ projectId }) {
    return <CollaborationPanel projectId={projectId} />;
}
